__webpack_public_path__ = window.__CDN_BASE_URL__ || "/"; //eslint-disable-line
